























































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { bookingModule } from '@/store';
import { loadStripe } from '@stripe/stripe-js';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: { ConfirmDialog },
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;

  paymentConfirm: boolean = false;

  stripe: any;
  card: any;

  errorMessage: string | null = null;

  style: any = {
    base: {
      color: '#fff',
      fontFamily:
        "'Cooper Hewitt', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: 'rgba(255, 255, 255, .8)',
      },
      iconColor: '#fff',
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  };

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Your booking will not be saved.';

  requiredCheckbox = [
    (v: boolean) =>
      v8n()
        .boolean()
        .equal(true)
        .test(v) || 'This field is required',
  ];

  get booking() {
    if (!bookingModule.booking) {
      return;
    }
    return bookingModule.booking;
  }

  bookingBack() {
    this.$router.back();
  }

  handleCardErrors() {
    this.card.on('change', (e: any) => {
      if (e.error) {
        this.errorMessage = e.error.message;
      } else {
        this.errorMessage = null;
      }
    });
  }

  async doPayment() {
    if (!this.booking) {
      return;
    }

    try {
      this.loading = true;
      const { paymentIntent, error } = await this.stripe.confirmCardPayment(
        this.booking.clientSecret,
        {
          payment_method: {
            card: this.card,
            billing_details: {
              email: this.booking.email,
              name: `${this.booking.firstName} ${this.booking.firstName}`,
              phone: this.booking.phoneNumber,
            },
          },
        },
      );
      if (error) {
        throw error;
      }
      this.errorMessage = null;

      bookingModule.setCompletedStep(7);
      this.$router.push({
        name: 'booking-step-8',
      });
    } catch (err) {
      // Error
      this.errorMessage = err.message;
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    bookingModule.setCurrentStep(7);
    bookingModule.checkStatus();

    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_API_KEY);

    const elements = this.stripe.elements();

    this.card = elements.create('card', { style: this.style });
    this.handleCardErrors();

    this.card.mount('#card-element');
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (to.name !== 'booking-step-8') {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }
}
